export const DEFAULT_SELECTORS = {
  modalContainerId: 'bp_container',
  lightBoxImgId: 'lightbox__img',
  nextBottomId: 'lightbox__arrow_right',
  prevBottomId: 'lightbox__arrow_left',
  navBotContPrevId: 'lightbox__arrow_left_container',
  navBotContNextId: 'lightbox__arrow_right_container',
  svgBottomPrevId: 'lightbox__arrow_left_svg',
  svgBottomNextId: 'lightbox__arrow_right_svg',
};

export const LIGHT_BOX_TEMPLATE = ({
  modalContainerId,
  lightBoxImgId,
  navBotContPrevId,
  svgBottomPrevId,
  prevBottomId,
  navBotContNextId,
  svgBottomNextId,
  nextBottomId,
} = DEFAULT_SELECTORS) => (`
        <div data-reactroot="" id="${modalContainerId}" class="lightbox" style="opacity: 0; display:none">
        <div class="lightbox__wrap">
          <div class="lightbox__picture">
            <img class="lightbox__img" id="${lightBoxImgId}" alt="" style="visibility: visible">
          </div>
        </div>
        <div>
          <i class="lightbox__close icon_1x84K" id="lightbox__close">
            <svg height="100%" width="100%">
              <use xlink:href="#sp-cross_20"></use>
            </svg>
          </i>
          <i class="lightbox__arrow _left icon_1x84K" id="${navBotContPrevId}" style="display: none">
            <svg height="100%" width="100%" id="${svgBottomPrevId}">
              <use xlink:href="#sp-arrow-next" id="${prevBottomId}"></use>
            </svg>
          </i>
          <i class="lightbox__arrow _right icon_1x84K" id="${navBotContNextId}" style="display: none">
            <svg height="100%" width="100%" id="${svgBottomNextId}">
              <use xlink:href="#sp-arrow-next" id="${nextBottomId}"></use>
            </svg>
          </i>
        </div>
      </div>
      `);

export const GALLERY_CONTAINER_SELECTOR = (hash) => (`.js-widget[data-widget="gallery"][data-widget-id="${hash}"]`);

export const NAVIGATIONS_BUTTONS_STYLES = {
  show: {
    display: 'block',
  },
  hide: {
    display: 'none',
  },
};

export const FADE_OUT_ANIMATION_DURATION = 250;
